import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyFirstProgram = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_py">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="60%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Python – First Program</h1>
                <hr style={{ color: "white" }}></hr>
                <div>
                  <p>
                    In this tutorial, we will learn how to run the first python
                    program using scripting mode. We will also discuss comments
                    in python. So far you have learned to install python and
                    IDLE, to start your first program, you need to search and
                    open IDLE in your PC. Now from python shell, select New from
                    the File menu or press{" "}
                    <span style={{ backgroundColor: "gray", color: "white" }}>
                      CTRL + N
                    </span>{" "}
                    to open a text editor, you need to write your code here (not
                    the Shell).
                  </p>
                </div>
                <div
                  // className="bg-info"
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <li> #First program to print Hello World</li>

                  <li>
                    <span className="python-function">print</span>(
                    <span className="python-string">"Hello World"</span>)
                  </li>
                </div>
                <p>
                  Now select File {`->`} Save As or press{" "}
                  <span style={{ backgroundColor: "gray", color: "white" }}>
                    CTRL + S{" "}
                  </span>
                  to save your code. Make sure you save python file with the
                  <span style={{ backgroundColor: "gray", color: "white" }}>
                    {" "}
                    .py{" "}
                  </span>
                  extension. You have successfully created your python program.
                  Finally select Run {`->`} Run Module or press
                  <span style={{ backgroundColor: "gray", color: "white" }}>
                    {" "}
                    F5
                  </span>{" "}
                  to execute your first code.
                </p>
                <br />
                <p>
                  <span style={{ fontWeight: "bold" }}>print()</span> – The
                  print() function in python is used to display information to
                  the users. You can print text, number, or both using print()
                  function. <br /> <span style={{ fontWeight: "bold" }}>#</span>{" "}
                  – It makes a line as a comment in python. Actually, the line
                  of comment is ignored by the python interpreter. Proper use of
                  commenting in a program gives more readability. You can
                  explain, what is going on your program using it.
                </p>
                <br />
                <p>
                  <span style={{ fontWeight: "bold" }}>
                    Single Line Comment in Python:
                  </span>{" "}
                  You can add comments to the program by typing # sign in front
                  of each line.
                </p>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <li>#This is a comment</li>
                  <li>#Second line of comment</li>
                  <li>#Third line of comment</li>

                  <li>
                    <span className="python-function">print</span>(
                    <span className="python-string">
                      "Learning Commenting in Python"
                    </span>
                    )
                  </li>
                </div>
                <br />
                <p>
                  <span style={{ fontWeight: "bold" }}>
                    Multiple Line Comment in Python:
                  </span>{" "}
                  You can write a multi-line comment using three single quotes
                  (or three double quotes).
                </p>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <li>'''</li>
                  <li>This is a comment</li>
                  <li>Second line of comment</li>
                  <li>Third line of comment</li>
                  <li>'''</li>

                  <li>
                    <span className="python-function">print</span>(
                    <span className="python-string">
                      "Using Multi-Line Comment"
                    </span>
                    )
                  </li>
                </div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
